import { IconMapPin } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import type { Delivery, Site } from "../../../../../utils/backend-types";
import type { Contract } from "../../../DeliveryOverview.types";
import { getSiteNameFromContractAndDeliveries } from "../utils/getSiteNameFromContractAndDeliveries";

const SITE_EMPTY = "empty";

export function getSiteColumn(
  contracts: Array<Contract>,
  deliveries: Array<Delivery>,
  sites: Array<Site>
): MRT_ColumnDef<Contract> {
  const sortedUsedSites = contracts
    .map((contract) =>
      getSiteNameFromContractAndDeliveries(contract, deliveries, sites)
    )
    .filter((siteName) => !!siteName)
    .sort((a, b) => (a ?? "").localeCompare(b ?? ""));
  const usedSitesSet = Array.from<string>(new Set(sortedUsedSites));
  const uniqueUsedSites = Array.from(usedSitesSet);

  return {
    accessorKey: "site",
    accessorFn: (row) => {
      return getSiteNameFromContractAndDeliveries(row, deliveries, sites) || "";
    },
    header: "Liegenschaft",
    filterVariant: "multi-select",
    filterTooltipValueFn: (value) =>
      value === SITE_EMPTY ? "(keine Liegenschaft)" : value,
    mantineFilterMultiSelectProps: {
      data: [{ value: SITE_EMPTY, label: "(keine Liegenschaft)" }].concat(
        uniqueUsedSites.map((site) => ({
          value: site,
          label: site
        }))
      )
    },
    filterFn: (row, _, filterValue) => {
      const site = getSiteNameFromContractAndDeliveries(
        row.original,
        deliveries,
        sites
      );

      if (filterValue.length === 0) {
        return true;
      }
      if (filterValue.includes(SITE_EMPTY) && !site) {
        return true;
      }
      return filterValue.includes(site);
    },
    Cell: (props) => <MantineIconCell {...props} IconComponent={IconMapPin} />
  };
}
